import { createI18n } from 'vue-i18n';

function loadLocaleMessages(): Record<string, any> {
  // Vite: eagerly import every locale JSON (recursive, incl. ./locales/countries).
  const modules = import.meta.glob('./locales/**/*.json', { eager: true });

  const messages: Record<string, any> = {};
  Object.entries(modules).forEach(([path, mod]) => {
    // Keys look like './locales/nl.json' or './locales/countries/nl-countries.json',
    // and the locale is the basename without the extension ('nl', 'nl-countries').
    // Done with slices rather than a regex: the previous
    // `path.match(/([A-Za-z0-9-_]+)\./i)` duplicated A-Za-z under the `i` flag and
    // SonarQube flagged it as super-linear backtracking (S5869 + S5852).
    const file = path.slice(path.lastIndexOf('/') + 1);
    const locale = file.slice(0, file.lastIndexOf('.'));
    if (locale) {
      messages[locale] = (mod as any).default ?? mod;
    }
  });
  return messages;
}

export default createI18n({
  legacy: false,
  locale: import.meta.env.VUE_APP_I18N_LOCALE || 'en-GB',
  fallbackLocale: import.meta.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-GB',
  messages: loadLocaleMessages(),
});
